export default "__VITE_ASSET__DaH45MBV__"